/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2} from "@mui/material";
import Tarjeta_Valores_Home from "../Tarjetas/Tarjeta_Valores_Home";
import audio from '../../../../Recursos/ic_audio.svg'
import espi from '../../../../Recursos/ic_espino.svg'
import optp from '../../../../Recursos/ic_opto.svg'
import visio from '../../../../Recursos/ic_visio.svg'
import labo from '../../../../Recursos/ic_labo.svg'

import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";


const Lista_Tarjeta_Valores_Home = () => {
    const {sCell} = useResponsive()

    return (
        <Grid2
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={12}
            spacing={sCell ? 8 : 14}>
            {valores.map((valor, index) => (

                <Grid2 container size={{xs: 12, sm: 6, md: 4}}>
                    <Tarjeta_Valores_Home
                        imagen={valor.imagen}
                        titulo={valor.titulo}
                        parrafo={valor.parrafo}/>
                </Grid2>

            ))}
        </Grid2>
    )

}
export default Lista_Tarjeta_Valores_Home


const valores = [

    {
        imagen: audio,
        titulo: 'Audiometría',
        parrafo: 'Evalúa la capacidad auditiva de cada oído y la orientación del sonido, detectando alteraciones tempranas en la audición.'
    },
    {
        imagen: espi,
        titulo: 'Espirometría',
        parrafo: 'Mide la función respiratoria para identificar posibles alteraciones pulmonares y fomentar su prevención y control.'
    },
    {
        imagen: optp,
        titulo: 'Optometría',
        parrafo: 'Examina la agudeza visual y salud ocular del paciente según los estándares laborales y riesgos ocupacionales.'
    },
    {
        imagen: visio,
        titulo: 'Visiometría',
        parrafo: 'Prueba visual que evalúa visión cercana y lejana, percepción de colores, profundidad y coordinación muscular ocular.'
    },
    {
        imagen: labo,
        titulo: 'Laboratorio Clínico',
        parrafo: 'Realiza pruebas específicas según los factores de riesgo ocupacionales para prevenir y detectar problemas de salud.'
    }

]